import React, { useState,useEffect } from "react";
import './CandidateDetails.scss';
import { useHeaderTitle } from "../../../components/layout/layout";
import { Details } from "../../../components/candidateDetails/details";

export default function CandidateDetails() {
       const { setHeaderTitle } = useHeaderTitle();   
    useEffect(() => {
               setHeaderTitle("Candidate Details");
              
           }, [setHeaderTitle]);
    return (
        <section>
            <Details />
        </section>
    );
}
